import { SagaIterator } from "redux-saga";
import { CreateLifeCycleRequest, LifeCycleReduxTypes } from "./types";
import { createLifeCycleApi } from "./api";
import { call, fork, put, takeEvery } from "redux-saga/effects";

function* createLifeCycle({payload}:CreateLifeCycleRequest):SagaIterator{
    try {
        const response = yield call(createLifeCycleApi, payload);
        yield put({
            type: LifeCycleReduxTypes.LIFE_CYCLE_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error:any) {
        yield put({
            type: LifeCycleReduxTypes.LIFE_CYCLE_REPORT_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchLifeCycle(){
    yield takeEvery(LifeCycleReduxTypes.LIFE_CYCLE_REPORT,createLifeCycle)
}

function* lifeCycleReportSaga(){
yield fork(watchLifeCycle)
}

export default lifeCycleReportSaga